/**
 * Конвертирует дату в UTC ISO-строку, сохраняя локальные компоненты даты/времени (без сдвига).
 * @param {Date|string} dateInput - Исходная дата.
 * @returns {string} ISO-строка с локальными значениями в UTC.
 */
function toUTCStartOfDay(dateInput) {
  const d = new Date(dateInput);
  const pad = (n, z = 2) => String(n).padStart(z, '0');

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T`
      + `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.`
      + `${String(d.getMilliseconds()).padStart(3, '0')}Z`;
}

export default toUTCStartOfDay;
